import { MultiSelectInput } from "common/form/inputs/multi_select";
import FieldWrapper from "common/form/enhancers/redux_form_field_wrapper";

export default FieldWrapper(MultiSelectInput);
